webpackJsonp([113972971054883],{

/***/ 1334:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Sprints in Tech: A Glimpse at How Dev Teams Work in the Real World ","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world","createdAt":"2018-03-16T00:07:49.486Z","blogAuthor":{"fields":{"name":"Danielle Martin","slug":"blog/author/danielle-martin"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5ax5pb45L2a8M6Yc2woCEO/651b664c1b06f7ae949c05c6708b01d2/blog-post-blog-sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world.jpg"}}}}}]},"authorJson":{"name":"Danielle Martin","slug":"blog/author/danielle-martin","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/danielle-martin"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-danielle-martin-cce3d45e9a3d68593ed0.js